import { Injectable } from "@angular/core";
import type { IApiResponse, Endpoint } from "src/app/models";
import { firstValueFrom, from, Observable, switchMap } from "rxjs";
import { HTTP_METHOD } from ".";
import { HttpService } from "../http.service";
import { UserService } from "../user.service";
import { UserTenant } from "src/app/models/user-tenant.model";

@Injectable({
  providedIn: "root",
})
export class UserTenantApiService {
  private _userTenant = "UserTenant" as Endpoint;

  constructor(
    private readonly http: HttpService,
    private readonly us: UserService
  ) {}

  /**
   * Gets all tenants a user is a part of
   *
   * @returns {Promise<IApiResponse<IHttpCheckUser>>} User data
   *
   * @deprecated use the Observable
   */
  async getAllTenants(): Promise<IApiResponse<UserTenant[]>> {
    const { userId } = await this.us.checkAndGetUserIds();
    return firstValueFrom(
      this.http.request$<UserTenant[]>(HTTP_METHOD.GET, this._userTenant, {
        params: { userId },
        skipCheck: true,
      })
    );
  }

  /**
   * Gets all tenants a user is a part of
   *
   * @returns {Promise<IApiResponse<IHttpCheckUser>>} User data
   */
  getAllTenants$(): Observable<IApiResponse<UserTenant[]>> {
    return from(this.us.checkAndGetUserIds()).pipe(
      switchMap(({ userId }) =>
        this.http.request$<UserTenant[]>(HTTP_METHOD.GET, this._userTenant, {
          params: { userId },
          skipCheck: true,
        })
      )
    );
  }
}
